import React from "react";

/*eslint-disable */

declare const window: any;
const TitleComponent: React.FC = () => {
  return (
    <div className="title-politicas-component">TÉRMINOS Y CONDICIONES DE USO RESERVA ONLINE DE VEHÍCULOS</div>
  );
};

export default TitleComponent;
